// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3kWNc","unreadBadge":"styles_unreadBadge__138Tu","modalContent":"styles_modalContent__JhJ6I","modal":"styles_modal__jCtAR"};